import { Edge, BackendEdge } from '../types';

/**
 * Parse edge to correspond to what G6 is expecting
 * Note that the ids need to be converted to strings.
 */
export const parseEdge = (edge: BackendEdge): Edge => ({
  ...edge,
  source: `${edge.srcWorkflowNodeId}`,
  sourceAnchor: edge.srcWorkflowNodeOutputIndex + 1,
  target: `${edge.destWorkflowNodeId}`,
  targetAnchor: 0,
});

export const updateEdgeDeleteStatus = (edge: Edge, canDelete: boolean): Edge => ({
  ...(edge || {}),
  canDelete,
});
